import { useEffect, useState } from "react";
import { Tag, Check, Copy } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function CouponBanner({ context = "" }) {
  const [coupon, setCoupon] = useState(null);
  const [applied, setApplied] = useState(false);

  useEffect(() => {
    api.get("/coupons/active").then((r) => {
      if (r.data && r.data.code) setCoupon(r.data);
    }).catch(() => {});
  }, []);

  if (!coupon) return null;

  const apply = async () => {
    try {
      const { data } = await api.post("/coupons/apply", { code: coupon.code, context });
      if (data.valid) {
        setApplied(true);
        navigator.clipboard?.writeText(coupon.code).catch(() => {});
        toast.success(`Kód ${coupon.code} skopírovaný — zľava ${coupon.percent}% na materiál.`);
      } else {
        toast.error(data.message || "Kód sa nepodarilo uplatniť.");
      }
    } catch {
      toast.error("Kód sa nepodarilo uplatniť.");
    }
  };

  return (
    <div data-testid="coupon-banner"
      className="border border-gold/40 bg-gold/5 px-5 py-4 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
      <div className="flex items-center gap-3">
        <Tag className="w-6 h-6 text-gold shrink-0" />
        <div>
          <p className="text-white font-semibold text-sm">Zľava {coupon.percent}% na {coupon.scope || "materiál"}</p>
          <p className="text-white/50 text-xs">Objednajte materiál cez našu platformu a ušetríte.</p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <span className="font-mono2 text-gold text-lg tracking-[3px] border border-dashed border-gold/50 px-4 py-2" data-testid="coupon-code">
          {coupon.code}
        </span>
        <button onClick={apply} data-testid="coupon-apply"
          className="bg-gold text-ink px-4 py-2.5 text-sm font-bold uppercase tracking-wider hover:bg-gold-light flex items-center gap-2">
          {applied ? <><Check className="w-4 h-4" /> Uplatnené</> : <><Copy className="w-4 h-4" /> Získať kód</>}
        </button>
      </div>
    </div>
  );
}
